export enum PrepaidRequestStatusEnum {
  PROS = 'PROSPECTED',
}
